import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "workpackage-settings" },
    [
      _c(
        "tooltip",
        {
          attrs: {
            value: _vm.$t("workpackageSettings.title"),
            position: "bottom",
          },
        },
        [
          _c(
            VBtn,
            {
              staticClass: "settings-trigger-btn",
              attrs: { icon: "" },
              on: { click: _vm.openModal },
            },
            [_c("workpackage-settings-icon")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        VDialog,
        {
          attrs: { persistent: "", width: "1200px" },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "workpackage-settings-modal" },
            [
              _c(
                VCardTitle,
                { staticClass: "modal-header" },
                [
                  _c("span", { staticClass: "text-h5 font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("workpackageSettings.title"))),
                  ]),
                  _vm._v(" "),
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    { attrs: { icon: "" }, on: { click: _vm.closeModal } },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(VDivider, { staticClass: "mx-3" }),
              _vm._v(" "),
              _c(VCardText, { staticClass: "modal-body" }, [
                _c(
                  "div",
                  { staticClass: "sections-row" },
                  [
                    _c(
                      "section",
                      {
                        staticClass: "settings-section",
                        attrs: {
                          "aria-labelledby": "data-refresh-history-heading",
                        },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "section-heading",
                            attrs: { id: "data-refresh-history-heading" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "workpackageSettings.sections.dataRefreshHistory"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.groupedDataRefreshHistory &&
                        Object.keys(_vm.groupedDataRefreshHistory).length
                          ? _c(
                              "div",
                              { staticClass: "history-list" },
                              _vm._l(
                                _vm.groupedDataRefreshHistory,
                                function (runs, date) {
                                  return _c(
                                    "div",
                                    { key: date, staticClass: "history-group" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "history-date" },
                                        [_vm._v(_vm._s(date))]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(runs, function (run) {
                                        return _c(
                                          "div",
                                          {
                                            key: run._id,
                                            staticClass: "history-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "history-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatTime(run.date)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "history-separator",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "history-description",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "workpackageSettings.dataRefreshRanBy",
                                                      { username: run.username }
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          : _c("p", { staticClass: "empty-section-text" }, [
                              _vm._v(_vm._s(_vm.$t("response.noData"))),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(VDivider, {
                      staticClass: "section-divider",
                      attrs: { vertical: "" },
                    }),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "settings-section",
                        attrs: {
                          "aria-labelledby": "engine-run-history-heading",
                        },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "section-heading",
                            attrs: { id: "engine-run-history-heading" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "workpackageSettings.sections.engineRunHistory"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.groupedEngineRunHistory &&
                        Object.keys(_vm.groupedEngineRunHistory).length
                          ? _c(
                              "div",
                              { staticClass: "history-list" },
                              _vm._l(
                                _vm.groupedEngineRunHistory,
                                function (runs, date) {
                                  return _c(
                                    "div",
                                    { key: date, staticClass: "history-group" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "history-date" },
                                        [_vm._v(_vm._s(date))]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(runs, function (run) {
                                        return _c(
                                          "div",
                                          {
                                            key: run._id,
                                            staticClass: "history-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "history-time" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatTime(run.date)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "history-separator",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "history-description",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getEngineRunEventLabel(
                                                      run
                                                    )
                                                  ) +
                                                    "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "workpackageSettings.ranBy",
                                                        {
                                                          username:
                                                            run.username,
                                                        }
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          : _c("p", { staticClass: "empty-section-text" }, [
                              _vm._v(_vm._s(_vm.$t("response.noData"))),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(VDivider, {
                      staticClass: "section-divider",
                      attrs: { vertical: "" },
                    }),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "settings-section",
                        attrs: {
                          "aria-labelledby": "workpackage-actions-heading",
                        },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass: "section-heading",
                            attrs: { id: "workpackage-actions-heading" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "workpackageSettings.sections.workpackageActions"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actions-container" },
                          [
                            _c(
                              "feature-toggle",
                              {
                                attrs: {
                                  toggle: _vm.enableCompetitorSimulation,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "cost-thresholds-section" },
                                  [
                                    !_vm.isCostThresholdsEditMode
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "cost-thresholds-display",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "display-content",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "workPackages.costChangeThresholds.label"
                                                        )
                                                      ) +
                                                      ":\n                        " +
                                                      _vm._s(
                                                        _vm.costThresholdsDisplayValue
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              VIcon,
                                              {
                                                staticClass: "edit-icon",
                                                attrs: {
                                                  color: "primary",
                                                  size: "1.5rem",
                                                },
                                                on: {
                                                  click:
                                                    _vm.toggleCostThresholdsEditMode,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      mdi-pencil\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "cost-thresholds-edit",
                                          },
                                          [
                                            _c("cost-threshold-inputs", {
                                              attrs: {
                                                workpackage:
                                                  _vm.workpackageForDialog,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "edit-actions" },
                                              [
                                                _c(
                                                  VBtn,
                                                  {
                                                    staticClass:
                                                      "cancel-edit-btn",
                                                    attrs: {
                                                      "x-small": "",
                                                      outlined: "",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.toggleCostThresholdsEditMode,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "actions.cancel"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "feature-toggle",
                              {
                                attrs: { toggle: _vm.enableRecalculateAllKPIs },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "action-btn",
                                    attrs: {
                                      outlined: "",
                                      disabled: _vm.isRecalculateDisabled,
                                      loading: _vm.recalculatingAll,
                                    },
                                    on: { click: _vm.recalculateKpis },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "workpackageSettings.actions.recalculateKpis"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isPriceValidationsEnabled && _vm.isAdminLoggedIn
                              ? _c(
                                  VTooltip,
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    VBtn,
                                                    {
                                                      staticClass: "action-btn",
                                                      attrs: {
                                                        outlined: "",
                                                        disabled:
                                                          _vm.isRerunValidationsDisabled,
                                                        loading:
                                                          _vm.rerunningPriceValidations,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.onRerunPriceValidations,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "workpackageSettings.actions.rerunValidations"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2698067116
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.rerunValidationsTooltip) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isLockAllTsgsVisible
                              ? _c(
                                  "div",
                                  { staticClass: "lock-all-tsgs-row" },
                                  [
                                    _c(VSwitch, {
                                      staticClass: "lock-all-switch mt-0",
                                      attrs: {
                                        "input-value": _vm.areAllTsgsLocked,
                                        disabled: _vm.isLockAllTsgsDisabled,
                                        loading: _vm.isLockAllLoading,
                                        dense: "",
                                        "hide-details": "",
                                      },
                                      on: { change: _vm.onLockAllTsgs },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "lock-all-label",
                                                  },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      {
                                                        staticClass: "mr-1",
                                                        attrs: { small: "" },
                                                      },
                                                      [_vm._v("mdi-lock")]
                                                    ),
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "workpackageSettings.actions.lockAllTsgs"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1882552468
                                      ),
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(VDivider, { staticClass: "mx-3" }),
              _vm._v(" "),
              _c(
                VCardActions,
                { staticClass: "modal-footer" },
                [
                  _c(VSpacer),
                  _vm._v(" "),
                  _c(
                    VBtn,
                    {
                      staticClass: "close-btn",
                      attrs: { outlined: "" },
                      on: { click: _vm.closeModal },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("actions.close")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "feature-toggle",
                    { attrs: { toggle: _vm.enableCompetitorSimulation } },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "save-changes-btn",
                          attrs: {
                            disabled:
                              _vm.hasCostThresholdValidationError ||
                              _vm.isSaving ||
                              !_vm.hasCostThresholdChanges,
                            loading: _vm.isSaving,
                          },
                          on: { click: _vm.saveThresholds },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "workpackageSettings.actions.saveChanges"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }